import Vue from 'vue';
import axios from 'axios';
import notification from 'ant-design-vue/es/notification';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import MapAccount from '@/libs/MapAccount';
import confirm from 'ant-design-vue/es/modal/confirm';

const BASE_URL = 'http://9.134.195.54:8080/mock/5e143ca289ebc74bc1564caa';
// 创建 axios 实例
const service = axios.create({
  baseURL: `${BASE_URL}/api`, // api base_url
  timeout: 0, // 请求超时时间
});

const err = (error) => {
  if (error.response) {
    const { data } = error.response;
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message,
      });
    } else if (error.response.status === 401) {
      confirm({
        title: '提示',
        content: '登录已失效，请重新登录！',
        onOk: () => {
          MapAccount.login();
        },
      });
    } else if (error.response.status === 500) {
      notification.error({
        message: '服务器出错了...',
      });
    } else {
      notification.error({
        message: '服务端发生问题...',
        description: error.response.status,
      });
    }
  }
  return Promise.reject(error);
};

// request interceptor
service.interceptors.request.use((req) => {
  const token = Vue.ls.get(ACCESS_TOKEN);
  if (token) {
    req.headers['Access-Token'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return req;
}, err);

// response interceptor
service.interceptors.response.use((response) => {
  const dataResponse = response.data;
  /**
   * 这里的返回值 error_no 应该替换为你跟服务端定义的接口返回格式
   */
  if (dataResponse.error_no !== 0 && isApplicationJson(response.headers['content-type'])) {
    notification.error({
      message: '错误',
      description: dataResponse.error_msg || '接口返回错误',
    });
    throw new Error(dataResponse.error_msg);
  }
  if (response.headers['content-disposition']) {
    const fileName = response.headers['content-disposition'].split(';')[1].split('=')[1].replace(/^"|"$/g, '');
    dataResponse.fileName = decodeURI(escape(fileName));
  }
  /**
   * 当服务端正确返回时：
   * {
   *   error_no: 0,
   *   error_msg: 'success',
   *   result: {
   *     data: []
   *   }
   * }
   * reponse 里面端数据只有result是对接下来的程序起作用的
   * 所以这里直接返回 response.result
   */
  return dataResponse.result;
}, err);

// install to vue instance
const VueServiceInstall = {
  install(Vue, axiosInstance = service) {
    console.assert(axiosInstance, `arguments error: axiosInstance=${axiosInstance}`);
    Object.defineProperties(Vue.prototype, {
      $http: {
        get: function get() {
          return axiosInstance;
        },
      },
    });
  },
};

function isApplicationJson(contentType) {
  return /application\/json/.test(contentType);
}

export {
  VueServiceInstall,
  service,
  service as axios,
};

export default service;
